var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-listagem" },
    [
      _vm.showModalVisualizarPortaria
        ? _c("visualizar-portaria", {
            attrs: {
              width: _vm.modalWidth,
              titulo: "Visualizar Portaria",
              bytes: _vm.portariaPdfBytes
            },
            on: { closeModal: _vm.closeModalVisualizarPortaria }
          })
        : _vm._e(),
      _vm.showModalVisualizarMatricula
        ? _c("visualizar-matricula", {
            attrs: {
              width: _vm.modalWidth,
              titulo: "Visualizar Matrícula",
              bytes: _vm.matriculaPdfBytes
            },
            on: { closeModal: _vm.closeModalVisualizarMatricula }
          })
        : _vm._e(),
      _vm.showModalAssinatura
        ? _c("modal-assinatura", {
            attrs: {
              width: _vm.modalWidth,
              titulo: "Assinar Ofício(s)",
              texto:
                "Para realizar a assinatura de ofícios é necessário informar a senha do seu certificado digital. Ao finalizar, o documento será assinado."
            },
            on: {
              closeModal: _vm.closeModalAssinatura,
              callbackSucesso: _vm.assinatura
            }
          })
        : _vm._e(),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c("Pesquisa", {
                attrs: {
                  placeHolder: "Informe o nome da Gleba ou nº do Processo",
                  cardStyle: { margin: "20px", "border-radius": "10px" }
                },
                on: {
                  search: _vm.handlePesquisa,
                  resetSearch: _vm.resetPesquisa
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("app-listagem", {
        attrs: {
          "has-refresh-button": true,
          showButtonOrdemServico: false,
          showButtonAssinatura: true,
          "has-expansivel": false,
          "json-headers": _vm.colunas,
          "json-data": _vm.processosArrecadacao,
          totalElements: _vm.totalCadastros,
          pagina: _vm.pagina,
          filtro: _vm.filtro,
          disableButtonAssinaturaTitulo: _vm.idsProcessosAssinatura.length == 0
        },
        on: {
          updateListagem: _vm.resetPesquisa,
          changePage: _vm.changePage,
          sort: _vm.sortChanged,
          selected: false,
          selectItem: _vm.selectItem,
          executar: _vm.executar,
          assinarTitulos: _vm.ASSINATURA
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73ce52ab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73ce52ab","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/gp/components/GpListagemPresidente.vue
// module id = null
// module chunks = 